/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {AntennaInstance} from "../models/antenna-instance";
import {AntennaService} from "../services/antenna.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class AntennaInstancesResolver implements Resolve<AntennaInstance[]> {

  constructor(
    private mAntennaService: AntennaService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AntennaInstance[]> {
    try {
      return await this.mAntennaService.getAllAntennaInstances();
    } catch (error) {
      console.error("Problem resolving Antenna Instances... Error: " + error, error);
    }
  }

}
